import axios from "axios";
import { cookies } from "@/common/cookieUtils";
import { login } from "./js/publicMethod";
const baseURL = require("@/config/APIs").API;

export default function ajax(options) {
  let tenant_id = localStorage.getItem("tenant")
    ? JSON.parse(localStorage.getItem("tenant")).id
    : "";
  let project_id = localStorage.getItem("project")
    ? JSON.parse(localStorage.getItem("project")).id
    : "";
  return cookies.getAuthorization().then(token => {
    if (!token) {
      login();
      return new Promise.reject();
    }
    let headers = {
      "Content-type": "application/json;charset=UTF-8",
      "X-Auth-Token": token || null,
      "X-Auth-Tenant": tenant_id || "",
      "X-Auth-Project": project_id || "",
      "Accept-Language": localStorage.getItem("local") || navigator.language
    };
    const ajaxObj = {
      method: options.method,
      baseURL: baseURL,
      url: options.url,
      timeout: options.timeout || 30000,
      params: options.params,
      // params: options.params || '',
      // headers: Object.assign(headers, options.headers),
      headers: headers,
      // data: JSON.stringify(options.data || '')
      data: JSON.stringify(options.data)
    };
    return axios(ajaxObj);
  });
}



// WEBPACK FOOTER //
// ./src/common/axiosHttp.js